import { Component, computed, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wl-review-stars',
  templateUrl: './review-stars.component.html',
  standalone: true,
  styleUrls: [
    './review-stars.component.essent.scss',
    './review-stars.component.ed.scss',
  ],
  imports: [FaIconComponent],
})
export class ReviewStarsComponent {
  readonly maxStars = input(5);
  readonly maxScore = input(10);
  readonly score = input(10);

  readonly numberOfStars = computed(() =>
    this.#roundToNearestHalf((this.score() * this.maxStars()) / this.maxScore())
  );

  readonly emptyStars = computed(() =>
    new Array(this.maxStars()).fill(['fas', 'star'])
  );
  readonly fullStars = computed(() =>
    new Array(Math.floor(this.numberOfStars())).fill(['fas', 'star'])
  );
  readonly showHalfStar = computed(() => this.numberOfStars() % 1 === 0.5);

  #roundToNearestHalf(num: number): number {
    return Math.round(num * 2) / 2;
  }
}
